<template>
  <footer class="app-footer">
    <a href="http://www.facturando.mx/">Administrador</a> &copy; 2017 Facturando.
    <span class="float-right">Creado por <a href="http://www.facturando.mx/">Facturando</a></span>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue